export default __webpack_public_path__ + "static/media/Modular Thermostat.c913d71b.pdf";